//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AccountMenu from '@/frontend/components/page-sections/account-menu'
import TableWithExtraHeader from '@/frontend/components/common/table-with-extra-header.vue'
import {mapActions, mapState} from 'vuex'
import {columnFormatterMixin} from '@/mixins/columnFormatterMixin'
import {attributeTypeCodes} from "@/enums/customAttributeTypeCodes";
import {getShoppingCartSID} from '@/utils/helpers'

export default {
  name: 'Wishlist',
  components: {TableWithExtraHeader, AccountMenu},
  mixins: [columnFormatterMixin],
  head() {
    return {
      title: "Wishlist"
    }
  },
  data() {
    return {
      loading: false,
      defaultHeaders: [
        {text: 'Image', value: 'image', width: '150px'},
        {text: 'Description', value: 'description'},
        {text: 'Price', value: 'price'},
        {text: 'Actions', value: 'actions'},
      ],
      breadCrumbItems: [
        {text: 'Home', disabled: false, href: '/'},
        {text: 'My Account', disabled: true},
        {text: 'My wishlist', disabled: true},
      ],
    }
  },
  computed: {
    ...mapState('wishList', ['wishListItems']),
    loggedIn() {
      return this.$store.state.auth.loggedIn
    },
  },
  mounted() {
    this.getWishListItems()
  },
  methods: {
    ...mapActions('shoppingCart', ['addToCart']),
    ...mapActions('wishList', ['getWishListItems', 'deleteWishlistItem']),
    getAttributeValue(attribute) {
      switch(attribute.attributeTypeCode){
        case attributeTypeCodes.LIST:
          return attribute.valueText
        default:
          return attribute.value
      }
    },
    addAllToCart() {
      this.loading = true
      this.wishListItems.forEach(async item => {
        const shoppingCartItem = this.prepareShoppingCartItem(
          item,
          1,
          undefined,
          item.subitems,
          item.attributes,
          item.imageUrl
        )

        await this.addToCart({
          shoppingCartItem,
          path: `/product-detail/${item.itemTypeCode}`,
        }).then(async (result) => {
          if (result.hasErrors) {
            this.$toast.error(result.errorMessages.error)
          }
          else{
            await this.deleteWishlistItem({wishListItemId: item.id})
          }
        }).catch(() => {
          this.$toast.error('Something went wrong')
        })
      })
      this.$toast.success('All items added to cart')
      this.loading = false
    },
    deleteItem(item) {
      this.loading = true
      this.deleteWishlistItem({wishListItemId: item.id}).then(
        (result) => {
          if (result.hasErrors) {
            this.$toast.error(result.errorMessages.error)
          } else {
            this.$toast.success('Item deleted')
          }
        }
      ).catch(() => {
        this.$toast.error('Something went wrong')
      }).finally(() => {
        this.loading = false
      })
    },
    async addItemToCart(wishlistItem){
      this.loading = true
      const shoppingCartItem = this.prepareShoppingCartItem(
        wishlistItem,
        1,
        undefined,
        wishlistItem.subitems,
        wishlistItem.attributes,
        wishlistItem.imageUrl
      )

      const result = await this.addToCart({
        shoppingCartItem,
        path: `/product-detail/${wishlistItem.itemTypeCode}`,
      })
      if (!result.hasErrors) {
        this.$toast.success('Item added to cart')
        await this.deleteWishlistItem({wishListItemId: wishlistItem.id})
      } else {
        this.$toast.error(result.errorMessages.error)
      }
      this.loading = false
    },
    prepareShoppingCartItem(item, quantity, metal, subItems, attributes, imageUrl) {
      const shoppingCartItem = {
        ItemTypeID: item.itemTypeID,
        Quantity: quantity,
        Notes: '',
        SessionID: getShoppingCartSID(),
        Name: item.itemTypeName,
      }

      shoppingCartItem.ItemTypeData = {
        ItemTypeID: item.itemTypeID,
        Quantity: 1,
        Price: item.price ? item.price : 0,
        Attributes: attributes,
        Subitems: subItems,
        Metal: metal,
        ImageUrl: imageUrl,
      }
      return shoppingCartItem
    },
  },
}
